$(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $('#header-right').addClass('fixed');
    } else {
      $('#header-right').removeClass('fixed');
    }
  });
});